import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
});

let currentTenantId = null;

export const setTenantId = (id) => {
    currentTenantId = id;
};

// Request interceptor
api.interceptors.request.use((config) => {
    // console.log('API Request:', config.method.toUpperCase(), config.url);
    const isSiteRequest = config.url && config.url.includes('/api/sites') && !config.url.includes('/api/sites/admin');
    const token = isSiteRequest ? localStorage.getItem('site_token') : localStorage.getItem('token');
    console.log('[API Request] Token found:', token ? 'YES' : 'NO');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        console.log('[API Request] Attached Authorization header');
    }

    // Automatically attach restaurantId to query params
    const restaurantId = currentTenantId || import.meta.env.VITE_RESTAURANT_ID;
    if (restaurantId) {
        config.params = {
            restaurantId: restaurantId,
            ...config.params
        };
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', error.response?.status, error.response?.data);
        return Promise.reject(error);
    }
);

export default api;